import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: import.meta.env.VITE_APP__SENTRY_DSN,
  environment: import.meta.env.VITE_APP__ENVIRONMENT,
  sendDefaultPii: true,
})
